import React, { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../globalhelper/helper";
import { CSVLink } from "react-csv";
import Checkbox from "@mui/material/Checkbox";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  AlertTitle,
  Box,
  Button,
  Typography,
  Grid,
  TextField,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { toast } from "react-toastify";
import moment from "moment";

const sectionOptions = [
  "194H-TDS on Commission(5%)",
  "194C-TDS on Contract-Company(2%)",
  "194C-TDS on Contract-Non Company(1%)",
  "194A-TDS on Interest(10%)",
  "194J-TDS Professional (10%)",
  "194J-TDS Professional (2%)",
  "194I-TDS Payable Rent(land/building/furniture)(10%)",
  "194I-TDS Payable Rent(plant and machinery)(2%)",
  "195-TDS U/s 195(10%)",
  "195-TDS U/s 195(20%)",
  "Equalisation Levy",
  "192-TDS On Salary(0%)"
];

const sectionPercentageMap = {
  "194H-TDS on Commission(5%)": -5,
  "194C-TDS on Contract-Company(2%)": -2,
  "194C-TDS on Contract-Non Company(1%)": -1,
  "194A-TDS on Interest(10%)": -10,
  "194J-TDS Professional (10%)": -10,
  "194J-TDS Professional (2%)": -2,
  "194I-TDS Payable Rent(land/building/furniture)(10%)": -10,
  "194I-TDS Payable Rent(plant and machinery)(2%)": -2,
  "195-TDS U/s 195(10%)": -10,
  "195-TDS U/s 195(20%)": -20,
  "Equalisation Levy": 0,
  "192-TDS On Salary(0%)": 0
};

const CreateGrn = () => {

  const [Companies, setCompanies] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [vendorFilter, setVendorFilter] = useState("");
  const [vendors, setVendors] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [openGrnDialog, setOpenGrnDialog] = useState(false);
  const [currencyFilter, setCurrencyFilter] = useState("");
  const [invoiceRefFilter, setInvoiceRefFilter] = useState("");
  const [groupedData, setGroupedData] = useState([]);
  const [exchangeRate, setExchangeRate] = useState("1.000");
  const [deductTds, setDeductTds] = useState("Yes");

  const [expandedGroups, setExpandedGroups] =
    useState({});

  useEffect(() => {

    getRequest("api/edureka/getVM1")
      .then(({ res }) => {

        if (res.status === "success") {

          const temp = JSON.parse(res.data);

          const vendorList = temp
            .map(item => ({
              vendorId: item["Vendor ID"],
              vendorName: item["Vendor Name"]
            }))
            .filter(
              (item, index, self) =>
                index === self.findIndex(
                  x => x.vendorId === item.vendorId
                )
            );

          setVendors(vendorList);
        }

      })
      .catch(console.error);

  }, []);

  const [formData, setFormData] = useState({
    company: null,
    fromDate: moment().startOf("month").format("YYYY-MM-DD"),
    toDate: moment().endOf("month").format("YYYY-MM-DD")
  });

  useEffect(() => {
    // Initial fetch for companies and vendors (similar to CreateProvision)
    getRequest("api/edureka/getCompanyAssignedToUser")
      .then(({ res }) => {
        setCompanies(res.data || []);
      })
      .catch(console.error);
  }, []);

  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRowSelect = (rowId, checked) => {

    setTableData(prev =>
      prev.map(row =>
        row.rowId === rowId
          ? { ...row, selected: checked }
          : row
      )
    );

    setFilteredData(prev =>
      prev.map(row =>
        row.rowId === rowId
          ? { ...row, selected: checked }
          : row
      )
    );

  };

  const handleTableInputChange = (
    rowId,
    field,
    value
  ) => {

    const updateRow = row => {

      if (row.rowId !== rowId)
        return row;

      const updatedRow = {
        ...row,
        [field]: value
      };

      const acceptedQty =
        parseFloat(
          updatedRow["Accepted Qty"]
        ) || 0;

      const rate =
        parseFloat(
          updatedRow["This GRN/SRN Rate"]
        ) || 0;

      const exchangeRate =
        parseFloat(updatedRow["Exchange Rate"]) || 1;

      updatedRow["Amt in Txn Curr"] =
        (acceptedQty * rate).toFixed(2);

      updatedRow["Amt in Lcl Curr"] =
        (
          acceptedQty *
          rate *
          exchangeRate
        ).toFixed(2);

      const tdsPercentage =
        parseFloat(
          updatedRow["Percentage of TDS"]
        ) || 0;

      updatedRow["TDS Amount"] =
        (
          (acceptedQty * rate)
          *
          Math.abs(tdsPercentage)
        ) / 100;

      return updatedRow;
    };

    setTableData(prev =>
      prev.map(updateRow)
    );

    setFilteredData(prev =>
      prev.map(updateRow)
    );

  };

  const handleSelectAll = (checked) => {

    setTableData(prev =>
      prev.map(row => ({
        ...row,
        selected: checked
      }))
    );

    setFilteredData(prev =>
      prev.map(row => ({
        ...row,
        selected: checked
      }))
    );

    const expanded = {};

    summaryData.forEach(group => {

      const key =
        `${group["Sender Name"]}_${group["Invoice Ref"]}`;

      expanded[key] = checked;
    });

    setExpandedGroups(expanded);

  };

  const handleSubmit = () => {
    console.log("HANDLE SUBMIT CALLED");
    const formattedFromDate = moment(formData.fromDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const formattedToDate = moment(formData.toDate, "YYYY-MM-DD").format("YYYY-MM-DD");

    getRequest(
      `api/edureka/getCreateGrnData?orgid=${formData.company?.orgid}&fromDate=${formattedFromDate}&toDate=${formattedToDate}`
    )
      .then(({ res }) => {
        const updatedData = (res.data || []).map((row, index) => {
          const formatNumber = (val) => val && !isNaN(val) ? parseFloat(val).toFixed(2) : val;
          const acceptedQty = parseFloat(row["Accepted Qty"]) || 0;
          const rate = parseFloat(row["This GRN/SRN Rate"]) || 0;
          const tdsPercentage = parseFloat(row["Percentage of TDS"]) || 0;

          return {
            ...row,
            "Order Qty": formatNumber(row["Order Qty"]),
            "Accepted Qty": formatNumber(row["Accepted Qty"]),
            "This GRN/SRN Rate": formatNumber(row["This GRN/SRN Rate"]),
            "TDS Amount": (((acceptedQty * rate) * tdsPercentage) / 100).toFixed(2),
            "Exchange Rate":
              row["Currency"] === "INR"
                ? "1.000"
                : (
                  parseFloat(
                    row["Exchange Rate"]
                  ) || 1
                ).toFixed(3),

            "Amt in Txn Curr":
              (
                acceptedQty * rate
              ).toFixed(2),

            "Amt in Lcl Curr":
              (
                acceptedQty *
                rate *
                (
                  parseFloat(
                    row["Exchange Rate"]
                  ) || 1
                )
              ).toFixed(2),
            selected: false,
            rowId: index + 1
          };
        });
        setTableData(updatedData);
        const grouped = {};
        updatedData.forEach(row => {

          const key =
            `${row["Sender Name"]}_${row["Invoice Ref"]}`;

          if (!grouped[key]) {

            grouped[key] = {
              groupId: key,
              vendor: row["Sender Name"],
              invoiceRef: row["Invoice Ref"],
              currency: row["Currency"],
              rowCount: 0,
              selected: false,
              children: []
            };
          }

          grouped[key].children.push(row);
          grouped[key].rowCount++;
        });

        setGroupedData(
          Object.values(grouped)
        );
        setFilteredData(updatedData);
        setShowFilters(true);
      })
      .catch(console.error);
  };

  const handleReset = () => {
    setFormData({
      company: null,
      fromDate: "",
      toDate: ""
    });
    setTableData([]);

    setShowFilters(false);
    setVendorFilter("");
    setFilteredData([]);
    setCurrencyFilter("");
    setInvoiceRefFilter("");
  };

  const displayColumns = [
    "GRN Number",
    "Sender Name",
    "Accounting Date",
    "Invoice Ref",
    "Line ID",
    "Order Description",
    "Accepted Qty",
    "This GRN/SRN Rate",
    "Invoice Date",
    "DocumentType",
    "Amt in Lcl Curr",
    "Amt in Txn Curr",
    "ForPrdFrom",
    "ForPrdTo",
    "CostAllocationMethod",
    "Currency",
    "Section Name",
    "Percentage of TDS",
    "TDS Amount",
    // "Exchange Rate",
  ];

  const applyFilters = (
    vendor,
    currency,
    invoiceRef
  ) => {

    let data = [...tableData];

    if (vendor) {
      data = data.filter(
        row => row["Sender Name"] === vendor
      );
    }

    if (currency) {
      data = data.filter(
        row => row["Currency"] === currency
      );
    }

    if (invoiceRef) {
      data = data.filter(
        row => row["Invoice Ref"] === invoiceRef
      );
    }

    setFilteredData(data);
  };

  const vendorOptions = [
    ...new Set(
      tableData.map(row => row["Sender Name"])
    )
  ].filter(Boolean);
  const currencyOptions = [
    ...new Set(
      tableData.map(row => row["Currency"])
    )
  ].filter(Boolean);

  const invoiceRefOptions = [
    ...new Set(
      tableData.map(row => row["Invoice Ref"])
    )
  ].filter(Boolean);

  const sortedData = [...filteredData].sort(
    (a, b) =>
      Number(b["Line ID"]) -
      Number(a["Line ID"])
  );

  const summaryData = Object.values(

    sortedData.reduce((acc, row) => {

      const key =
        `${row["Sender Name"]}_${row["Invoice Ref"]}`;


      if (!acc[key]) {

        acc[key] = {
          ...row,
          parentRowId: row.rowId,
          lineCount: 0,
          children: []
        };

      }


      acc[key].lineCount++;
      acc[key].children.push(row);

      return acc;

    }, {})
  );



  const handleGroupSelect = (
    groupId,
    checked
  ) => {

    const group = summaryData.find(
      g => `${g["Sender Name"]}_${g["Invoice Ref"]}` === groupId
    );

    if (group?.["GRN Number"]) {
      return;
    }

    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: checked
    }));

    setTableData(prev =>
      prev.map(row => {

        const key =
          `${row["Sender Name"]}_${row["Invoice Ref"]}`;

        if (key !== groupId) return row;

        return {
          ...row,
          selected: checked
        };
      })
    );


    setFilteredData(prev =>
      prev.map(row => {

        const key =
          `${row["Sender Name"]}_${row["Invoice Ref"]}`;

        if (key !== groupId) return row;

        return {
          ...row,
          selected: checked
        };
      })
    );

  };

  const handleCreateGrn = async ({
    exchangeRate,
    deductTds
  }) => {

    try {

      let selectedData = tableData.filter(
        row => row.selected
      );

      selectedData = selectedData.map(row => {

        const acceptedQty =
          parseFloat(row["Accepted Qty"]) || 0;

        const rate =
          parseFloat(
            row["This GRN/SRN Rate"]
          ) || 0;

        const exRate =
          row["Currency"] === "INR"
            ? 1.000
            : parseFloat(exchangeRate || 1.000);

        return {
          ...row,

          "Exchange Rate":
            exRate.toFixed(3),

          "Amt in Txn Curr":
            (
              acceptedQty * rate
            ).toFixed(2),

          "Amt in Lcl Curr":
            (
              acceptedQty *
              rate *
              exRate
            ).toFixed(2),

          DeductionRef:
            deductTds === "Yes"
              ? "DeductTDS"
              : false
        };
      });

      console.log(
        "FINAL GRN DATA",
        JSON.stringify(selectedData, null, 2)
      );

      console.table(selectedData);

      if (!selectedData.length) {
        toast.warning(
          "Please select at least one row"
        );
        return;
      }

      // showLoader irundha add pannunga
      // dispatch(showLoader());

      const headers = Object.keys(selectedData[0])
        .filter(
          key =>
            key !== "selected" &&
            key !== "rowId"
        );

      const csvContent = [
        headers.join(","),
        ...selectedData.map(row =>
          headers
            .map(h => `"${row[h] ?? ""}"`)
            .join(",")
        )
      ].join("\n");

      const blob = new Blob(
        [csvContent],
        { type: "text/csv" }
      );

      const file = new File(
        [blob],
        "CreateGRN.csv",
        { type: "text/csv" }
      );

      const uploadFormData = new FormData();

      uploadFormData.append(
        "file",
        file
      );

      const encodedThemeName =
        encodeURIComponent("G&SRNIV1");

      const response = await postRequest(
        `api/upload/singleUpload2?OrgID=${formData.company?.orgid || ""}
      &TransactionType=GRN
      &ThemeName=${encodedThemeName}
      &GSTIN=
      &From=${formData.fromDate}
      &To=${formData.toDate}
      &ProcessCode=BT3I`
          .replace(/\s+/g, ""),
        uploadFormData
      );

      console.log(response);

      toast.success(
        "GRN uploaded successfully"
      );

      setOpenGrnDialog(false);

      setTimeout(() => {
        handleReset();
        setGroupedData([]);
        setExpandedGroups({});
      }, 1500);
    } catch (err) {

      console.error(err);

      toast.error(
        "Failed to create GRN"
      );

    } finally {

      // dispatch(hideLoader());

    }

  };

  const selectedRows =
    tableData.filter(
      row => row.selected
    );

  const allInr =
    selectedRows.length > 0 &&
    selectedRows.every(
      row => row["Currency"] === "INR"
    );


  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Create GRN</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Autocomplete
                size="small"
                value={formData.company}
                options={Companies}
                getOptionLabel={(option) => option?.orgname || ""}
                onChange={(e, value) => handleChange("company", value)}
                renderInput={(params) => (
                  <TextField {...params} label="Company" />
                )}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Inbox Period From"
                InputLabelProps={{ shrink: true }}
                value={formData.fromDate}
                onChange={(e) => handleChange("fromDate", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Inbox Period To"
                InputLabelProps={{ shrink: true }}
                value={formData.toDate}
                onChange={(e) => handleChange("toDate", e.target.value)}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={
                  !formData.company ||
                  !formData.fromDate ||
                  !formData.toDate
                }
              >
                Submit
              </Button>
              <Button
                color="error"
                variant="contained"
                sx={{ ml: 1 }}
                onClick={handleReset}
              >
                Reset
              </Button>
            </Grid>
            <Grid item sx={{ ml: "auto" }}>
              {tableData.length > 0 && (
                <Button
                  color="success"
                  variant="contained"
                  sx={{ ml: 1 }}
                >
                  <CSVLink
                    data={tableData}
                    filename="Create_GRN.csv"
                    style={{
                      color: "white",
                      textDecoration: "none"
                    }}
                  >
                    Download
                  </CSVLink>
                </Button>
              )}

              {tableData.some(row => row.selected) && (
                <Button
                  color="primary"
                  variant="contained"
                  sx={{ ml: 1 }}
                  onClick={() => {

                    const selectedData =
                      tableData.filter(
                        row => row.selected
                      );

                    if (!selectedData.length) {
                      toast.warning(
                        "Please select at least one row"
                      );
                      return;
                    }

                    if (
                      selectedData.every(
                        row => row["Currency"] === "INR"
                      )
                    ) {
                      setExchangeRate("1.000");
                    }

                    setOpenGrnDialog(true);

                  }}
                >
                  Create GRN
                </Button>
              )}
            </Grid>
          </Grid>
        </AccordionDetails>


      </Accordion>

      {showFilters && (

        <Accordion defaultExpanded sx={{ mt: 2 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography variant="h6">
              Filter GRN
            </Typography>
          </AccordionSummary>

          <AccordionDetails>

            <Grid container spacing={2}>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  size="small"
                  options={vendorOptions}
                  getOptionLabel={(option) =>
                    option || ""
                  }
                  value={vendorFilter || null}
                  onChange={(e, value) => {
                    const vendorName = value || "";
                    setVendorFilter(vendorName);
                    applyFilters(
                      vendorName,
                      currencyFilter,
                      invoiceRefFilter
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Vendor Name"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  size="small"
                  options={currencyOptions}
                  value={currencyFilter || null}
                  onChange={(e, value) => {

                    const selected =
                      value || "";

                    setCurrencyFilter(selected);

                    applyFilters(
                      vendorFilter,
                      selected,
                      invoiceRefFilter
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Currency"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  size="small"
                  options={invoiceRefOptions}
                  value={invoiceRefFilter || null}
                  onChange={(e, value) => {

                    const selected =
                      value || "";

                    setInvoiceRefFilter(selected);

                    applyFilters(
                      vendorFilter,
                      currencyFilter,
                      selected
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Invoice Ref"
                    />
                  )}
                />
              </Grid>
            </Grid>


          </AccordionDetails>
        </Accordion>
      )}

      {tableData.length ? (
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Checkbox
                    checked={
                      summaryData.length > 0 &&
                      summaryData.every(group =>
                        expandedGroups[
                        `${group["Sender Name"]}_${group["Invoice Ref"]}`
                        ]
                      )
                    }
                    indeterminate={
                      tableData.some(row => row.selected) &&
                      !tableData.every(row => row.selected)
                    }
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                </TableCell>
                {displayColumns.map((column) => (
                  <TableCell key={column}>{column}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>

              {summaryData.map((row, index) => {

                const key =
                  `${row["Sender Name"]}_${row["Invoice Ref"]}`;


                return (
                  <React.Fragment key={key}>
                    <TableRow
                      key={key}
                      sx={{
                        backgroundColor:
                          expandedGroups[key]
                            ? "#a0d3ff"
                            : "transparent"
                      }}
                    >
                      <TableCell
                        onClick={() =>
                          handleGroupSelect(
                            key,
                            !expandedGroups[key]
                          )
                        }
                        sx={{ cursor: "pointer" }}
                      >
                        <Checkbox
                          disabled={!!row["GRN Number"]}
                          checked={expandedGroups[key] || false}
                          onChange={(e) =>
                            handleGroupSelect(
                              key,
                              e.target.checked
                            )
                          }
                        />
                      </TableCell>
                      {displayColumns.map((column) => (
                        <TableCell key={column}>
                          {column === "Section Name" ? (
                            <Select
                              size="small"
                              value={row["Section Name"] || ""}
                              onChange={(e) => {

                                const sectionName = e.target.value;
                                const percentage =
                                  sectionPercentageMap[sectionName] ?? 0;

                                const updateRow = r => {

                                  if (r.rowId !== row.rowId)
                                    return r;

                                  const acceptedQty =
                                    Number(r["Accepted Qty"] || 0);

                                  const rate =
                                    Number(r["This GRN/SRN Rate"] || 0);

                                  return {
                                    ...r,
                                    "Section Name": sectionName,
                                    "Percentage of TDS": percentage,
                                    "TDS Amount":
                                      (
                                        (acceptedQty * rate)
                                        *
                                        Math.abs(percentage)
                                      ) / 100
                                  };
                                };

                                setTableData(prev =>
                                  prev.map(updateRow)
                                );

                                setFilteredData(prev =>
                                  prev.map(updateRow)
                                );

                              }}
                              sx={{ minWidth: 200 }}
                            >
                              {[
                                row["Section Name"],
                                ...sectionOptions.filter(
                                  option => option !== row["Section Name"] && option
                                )
                              ].filter(Boolean).map(option => (
                                <MenuItem
                                  key={option}
                                  value={option}
                                >
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : column === "Exchange Rate" ? (

                            row["Currency"] === "INR" ? (
                              row["Exchange Rate"] || "1.000"
                            ) : (
                              <TextField
                                size="small"
                                type="number"
                                value={row[column] || ""}
                                onChange={(e) =>
                                  handleTableInputChange(
                                    row.rowId,
                                    column,
                                    e.target.value
                                  )
                                }
                                onBlur={(e) => {
                                  if (
                                    e.target.value !== "" &&
                                    !isNaN(e.target.value)
                                  ) {
                                    handleTableInputChange(
                                      row.rowId,
                                      column,
                                      parseFloat(e.target.value).toFixed(3)
                                    );
                                  }
                                }}
                                sx={{ minWidth: 150 }}
                              />
                            )

                          ) : ["Order Qty", "Accepted Qty", "This GRN/SRN Rate", "Percentage of TDS"].includes(column) ? (
                            <TextField
                              size="small"
                              type="number"
                              value={row[column] || ""}
                              onChange={(e) =>
                                handleTableInputChange(
                                  row.rowId,
                                  column,
                                  e.target.value
                                )
                              }
                              onBlur={(e) => {
                                if (e.target.value !== "" && !isNaN(e.target.value)) {
                                  const decimals =
                                    column === "Exchange Rate"
                                      ? 3
                                      : 2;

                                  handleTableInputChange(
                                    row.rowId,
                                    column,
                                    parseFloat(e.target.value).toFixed(decimals)
                                  );
                                  // handleTableInputChange(index, column, parseFloat(e.target.value).toFixed(2));
                                }
                              }}
                              sx={{ minWidth: 150 }}
                            />
                          ) : (
                            row[column]
                          )}
                        </TableCell>
                      ))}
                    </TableRow>

                    {expandedGroups[key] &&

                      row.children
                        ?.filter(
                          child =>
                            child.rowId !== row.parentRowId
                        )
                        .map(child => (

                          <TableRow
                            key={child.rowId}
                            sx={{
                              backgroundColor:
                                expandedGroups[key]
                                  ? "#a0d3ff"
                                  : "#f8f8f8"
                            }}
                          >


                            <TableCell sx={{ pl: 6 }} />

                            {displayColumns.map((column) => (
                              <TableCell key={column}>
                                {column === "Section Name" ? (
                                  <Select
                                    size="small"
                                    value={child["Section Name"] || ""}
                                    onChange={(e) => {

                                      const sectionName = e.target.value;
                                      const percentage =
                                        sectionPercentageMap[sectionName] ?? 0;

                                      const updateRow = r => {

                                        if (r.rowId !== child.rowId)
                                          return r;

                                        const acceptedQty =
                                          Number(r["Accepted Qty"] || 0);

                                        const rate =
                                          Number(r["This GRN/SRN Rate"] || 0);

                                        return {
                                          ...r,
                                          "Section Name": sectionName,
                                          "Percentage of TDS": percentage,
                                          "TDS Amount":
                                            (
                                              (acceptedQty * rate)
                                              *
                                              Math.abs(percentage)
                                            ) / 100
                                        };
                                      };

                                      setTableData(prev =>
                                        prev.map(updateRow)
                                      );

                                      setFilteredData(prev =>
                                        prev.map(updateRow)
                                      );

                                    }}
                                    sx={{ minWidth: 200 }}
                                  >
                                    {[
                                      child["Section Name"],
                                      ...sectionOptions.filter(
                                        option => option !== child["Section Name"] && option
                                      )
                                    ].filter(Boolean).map(option => (
                                      <MenuItem
                                        key={option}
                                        value={option}
                                      >
                                        {option}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                ) : column === "Exchange Rate" ? (

                                  child["Currency"] === "INR" ? (
                                    child["Exchange Rate"] || "1.000"
                                  ) : (
                                    <TextField
                                      size="small"
                                      type="number"
                                      value={child[column] || ""}
                                      onChange={(e) =>
                                        handleTableInputChange(
                                          child.rowId,
                                          column,
                                          e.target.value
                                        )
                                      }
                                      onBlur={(e) => {
                                        if (
                                          e.target.value !== "" &&
                                          !isNaN(e.target.value)
                                        ) {
                                          handleTableInputChange(
                                            child.rowId,
                                            column,
                                            parseFloat(e.target.value).toFixed(3)
                                          );
                                        }
                                      }}
                                      sx={{ minWidth: 150 }}
                                    />
                                  )

                                ) : ["Order Qty", "Accepted Qty", "This GRN/SRN Rate", "Percentage of TDS"].includes(column) ? (
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={child[column] || ""}
                                    onChange={(e) =>
                                      handleTableInputChange(
                                        child.rowId,
                                        column,
                                        e.target.value
                                      )
                                    }
                                    onBlur={(e) => {
                                      if (e.target.value !== "" && !isNaN(e.target.value)) {
                                        const decimals =
                                          column === "Exchange Rate"
                                            ? 3
                                            : 2;

                                        handleTableInputChange(
                                          child.rowId,
                                          column,
                                          parseFloat(e.target.value).toFixed(decimals)
                                        );
                                        // handleTableInputChange(index, column, parseFloat(e.target.value).toFixed(2));
                                      }
                                    }}
                                    sx={{ minWidth: 150 }}
                                  />
                                ) : (
                                  child[column]
                                )}
                              </TableCell>
                            ))}


                          </TableRow>

                        ))}
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
          <Dialog
            open={openGrnDialog}
            onClose={() =>
              setOpenGrnDialog(false)
            }
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                width: 600,
                minHeight: 250
              }
            }}
          >
            <DialogTitle>
              Create GRN
            </DialogTitle>

            <DialogContent>

              {!allInr && (
                <>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, fontWeight: 500 }}
                  >
                    Exchange Rate
                  </Typography>

                  <TextField
                    fullWidth
                    size="small"
                    value={exchangeRate}
                    onChange={(e) =>
                      setExchangeRate(e.target.value)
                    }
                    sx={{ mb: 3 }}
                  />
                </>
              )}

              <Typography
                variant="body2"
                sx={{ mb: allInr ? 2.5 : 1, fontWeight: 500 }}
              >
                Are you sure you want to deduct TDS?
              </Typography>

              <FormControl
                fullWidth
                size="small"
              >


                <Select
                  value={deductTds}
                  onChange={(e) =>
                    setDeductTds(e.target.value)
                  }
                >
                  <MenuItem value="Yes">
                    Yes
                  </MenuItem>

                  <MenuItem value="No">
                    No
                  </MenuItem>
                </Select>
              </FormControl>

            </DialogContent>

            <DialogActions>

              <Button
                onClick={() => {
                  setOpenGrnDialog(false);

                  handleCreateGrn({
                    exchangeRate,
                    deductTds
                  });
                }}
              >
                Submit
              </Button>

              <Button
                onClick={() =>
                  setOpenGrnDialog(false)
                }
              >
                Cancel
              </Button>

            </DialogActions>

          </Dialog>
        </TableContainer>
      ) : (
        <Box sx={{ mt: 2 }}>
          <Alert severity="info">
            <AlertTitle>Info</AlertTitle>
            Submit to fetch data.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default CreateGrn;
